import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const loginRoutine = createRoutine('Login')
export const createLoginPromise = promisifyRoutine(loginRoutine)
